import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { CMSContentService } from '../../essentials/cms/content/cms-content.service';

export interface FilterData {
  buttons: Array<{
    title: string;
    url: string;
    color: string;
  }>;
  cards: Array<{ title: string; subtitle: string; link: string; }>;
  descriptionHighlight: string;
  linksHeader: Array<{
    title: string;
    icon: string;
    url: string;
  }>;
  subtitle: string;
  title: string;
}

@Component({
  selector: 'fcp-prospec',
  templateUrl: './prospec.component.html',
  styleUrls: ['./prospec.component.scss']
})
export class FilterProspecComponent implements OnInit {

  public filterData: FilterData;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cmsContentService: CMSContentService,
  ) { }

  ngOnInit() {
    window?.scrollTo(0, 0);
    this.route.params.subscribe((params) => {
      this.cmsContentService.getFilter(params['id'])
        .subscribe((data: Array<FilterData>) => {
          this.filterData = data.shift();
        });
    });
  }

}
